import styled from 'styled-components'
import { InlineMessage } from 'components/message'
import { Helper } from 'components/form/field/s'
import { Grid } from 'components/grid'

export const ModalHeaderMessage = styled(InlineMessage)`
    margin-block-start: 24px;
`

export const FlowHelper = styled(Helper)`
    margin-block: 0 24px;
`

export const StatusLayout = styled(Grid)`
    grid-auto-rows: auto;
    grid-auto-flow: row;
    grid-gap: 16px;
    margin-block-end: 24px;
`